<!-- Nav Menu -->

<template>
  <div id="app">
    <template v-if="$route.name == 'home'">
      <Menu
        @season="setSeason"
        @course="setCourse"
        @multiTourns="setMultiCourse"
        @log="setLog"
        @currentReport="setReport"
        @currentTitle="setTitle"
        @apiClass="setapiClass"
        :foot="false"
        :config="env"
      />
      <transition name="fade" appear>
        <router-view
          :key="$route.fullPath"
          :season="season"
          :currentReport="currentReport"
          :course="course"
          :multiTourns="multiTourns"
          :apiClass="apiClass"
          :title="currentTitle"
          :config="env"
          :loggedin='log'
      />
      </transition>
      <CookieBanner />
      <WatchLive />    
      <Footer
        :season="season"
        :currentReport="currentReport"
        :course="course"
        :apiClass="apiClass"
        :title="currentTitle"
        :config="env"
      />
    </template>
    <template v-else>
      <Menu
        @season="setSeason"
        @course="setCourse"
        @multiTourns="setMultiCourse"
        @log="setLog"
        @currentReport="setReport"
        @currentTitle="setTitle"
        @apiClass="setapiClass"
        :foot="false"
        :config="env"
      />
      <transition name="fade" appear>
        <router-view
          :key="$route.fullPath"
          :season="season"
          :currentReport="currentReport"
          :course="course"
          :multiTourns="multiTourns"
          :apiClass="apiClass"
          :config="env"
          :loggedin='log'
      />
      </transition>
      <CookieBanner />  
      <WatchLive />    
      <Footer
        :season="season"
        :currentReport="currentReport"
        :course="course"
        :apiClass="apiClass"
        :title="currentTitle"
        :config="env"
      />
    </template>
  </div>
</template>

<style>
a {
  color: #337ab7 !important;
  text-decoration: none;
  background-color: transparent;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-active {
  transition-delay: 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#app {
  /* font-family: "Open sans", sans-serif !important; */
  /* */
  font-family: sans-serif;
  /* background-color: rgb(249, 249, 249); */
  /* background: url(https://updated.sunshinetour.com/wp-content/uploads/2021/04/SunshineTourBG_2-scaled-1.jpeg); */
  background-repeat: no-repeat;
  background-attachment: fixed;
  font-size: 1rem;
  /* font-weight: 400; */
  line-height: 1.5;
}
/* @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap'); */
@font-face {
  font-family: "Sans-Serif";
  src: url("/fonts/BAHNSCHRIFT.TTF") format("TTF"), url("/fonts/BAHNSCHRIFT.TTF")
      format("TTF");
}
/* @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@900&display=swap'); */
li.nav-item::marker {
  color: transparent;
}
.cookie-banner {
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  max-width: 900px;
  margin: 0 auto;
  background: #1f1f1f;
  color: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  animation: cookieSlideUp .35s ease;
}

.cookie-banner p {
  margin: 0;
  line-height: 1.6;
  font-size: 15px;
  flex: 1;
}

.cookie-banner .buttons {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.cookie-banner button {
  border: none;
  border-radius: 8px;
  padding: 12px 22px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all .2s ease;
}

.cookie-banner button:first-of-type {
  background: transparent;
  border: 1px solid #666;
  color: #fff;
}

.cookie-banner button:first-of-type:hover {
  background: #333;
}

.cookie-banner button:last-of-type {
  background: #00a651;
  color: #fff;
}

.cookie-banner button:last-of-type:hover {
  background: #008d45;
  transform: translateY(-1px);
}

@keyframes cookieSlideUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .cookie-banner {
    left: 10px;
    right: 10px;
    bottom: 10px;
    padding: 18px;
    flex-direction: column;
    align-items: stretch;
  }

  .cookie-banner .buttons {
    width: 100%;
    flex-direction: column;
  }

  .cookie-banner button {
    width: 100%;
  }
}
</style>
<script>
  <meta name="apple-itunes-app" content="app-id=419098478"></meta>
</script>
<script>
import Menu from "@/components/menu.vue";
import Footer from "@/components/footer.vue";
import CookieBanner from "@/components/CookieBanner.vue";
import WatchLive from "@/components/WatchLive.vue";
export default {
  components: {
    Menu,
    Footer,
    CookieBanner,
    WatchLive
  },
  data() {
    return {
      course: "",
      multiTourns: '',
      currentReport: "",
      season: "",
      currentTitle: "",
      env:[],
      log:'',
      apiClass:''
    };
  },
  mounted() {
    this.env = process.env
  },
  metaInfo: {
    title: 'Sunshine Tour',
    titleTemplate: '%s | Sunshine Tour'
  },
  methods: {
    // Define method that will use the payload to update the data property
    setSeason(payload) {
      this.season = payload.season;
    },
    setCourse(payload) {
      this.course = payload.course;
    },
    setMultiCourse(payload) {
      this.multiTourns = payload.multiTourns;
    },
    setReport(payload) {
      this.currentReport = payload.currentReport;
    },
    setTitle(payload) {
      this.currentTitle = payload.currentTitle;
    },
    setLog(payload) {
      this.log = payload.log;
    },
    setapiClass(payload) {
      this.apiClass = payload.apiClass;
    },
  },
};
</script>
